import { colord, extend } from "colord";
import namesPlugin from "colord/plugins/names";

extend([namesPlugin]);

/**
 * Returns the hex color of the given color (supports named colors and rest of the common formats)
 */
export const getHexColor = (color: string) => colord(color).toHex();

/**
 * Returns true if the color is considered dark
 */
export const isColorDark = (color: string) => colord(color).brightness() < 0.6;

/**
 * Returns either white or black text color based on the brightness of the background color
 */
export const getReadableTextColorForBackground = (
  backgroundColor: string
): string => (isColorDark(backgroundColor) ? "#ffffff" : "#000000");
